/**
 * Objekt för ikryssade år ovanför datepickern
 */
export class YearCheck {
    constructor(
        public year: number,
        public checked: boolean = false,
        public disabled: boolean = false
    ) { }
}
